import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page16({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Exercise 08 Bicep Curl'
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'Machine Bicep Curl',
						},
						{
							header: '# of sets',
							value: '1 - 2',
						},
						{
							header: 'REPS / Weight',
							value: '8 - 10 Mild',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Working Set, Full Contraction',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Machine Bicep Curl',
						},
						{
							header: '# of sets',
							value: '3',
						},
						{
							header: 'REPS / Weight',
							value: 'Light - Mild',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full on Set (Burn Out)',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
